/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * teetime-api
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "../client";
export const getUser = (options, signal) => {
    return client({ url: `/user`, method: "GET", signal }, options);
};
export const getGetUserQueryKey = () => {
    return [`/user`];
};
export const getGetUserQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey();
    const queryFn = ({ signal, }) => getUser(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetUser = (options) => {
    const queryOptions = getGetUserQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const createUser = (createUserParams, options) => {
    return client({
        url: `/user`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createUserParams,
    }, options);
};
export const getCreateUserMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createUser(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateUser = (options) => {
    const mutationOptions = getCreateUserMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateUser = (pickUpdateUserParamsExcludeKeyofUpdateUserParamsFirebaseUid, options) => {
    return client({
        url: `/user`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: pickUpdateUserParamsExcludeKeyofUpdateUserParamsFirebaseUid,
    }, options);
};
export const getUpdateUserMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return updateUser(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateUser = (options) => {
    const mutationOptions = getUpdateUserMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStripeCreateCheckoutSession = (getStripeCreateCheckoutSessionBody, options) => {
    return client({
        url: `/stripe/create-checkout-session`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: getStripeCreateCheckoutSessionBody,
    }, options);
};
export const getGetStripeCreateCheckoutSessionMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return getStripeCreateCheckoutSession(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useGetStripeCreateCheckoutSession = (options) => {
    const mutationOptions = getGetStripeCreateCheckoutSessionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const createOrRetrieveStripeCustomer = (createOrRetrieveStripeCustomerBody, options) => {
    return client({
        url: `/stripe/customer`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createOrRetrieveStripeCustomerBody,
    }, options);
};
export const getCreateOrRetrieveStripeCustomerMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createOrRetrieveStripeCustomer(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateOrRetrieveStripeCustomer = (options) => {
    const mutationOptions = getCreateOrRetrieveStripeCustomerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const handleStripeWebhook = (handleStripeWebhookBody, headers, options) => {
    return client({
        url: `/stripe/webhook`,
        method: "POST",
        headers: { "Content-Type": "application/json", ...headers },
        data: handleStripeWebhookBody,
    }, options);
};
export const getHandleStripeWebhookMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data, headers } = props ?? {};
        return handleStripeWebhook(data, headers, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useHandleStripeWebhook = (options) => {
    const mutationOptions = getHandleStripeWebhookMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStripeSubscriptionProducts = (options, signal) => {
    return client({ url: `/stripe/subscription/products`, method: "GET", signal }, options);
};
export const getGetStripeSubscriptionProductsQueryKey = () => {
    return [`/stripe/subscription/products`];
};
export const getGetStripeSubscriptionProductsQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStripeSubscriptionProductsQueryKey();
    const queryFn = ({ signal }) => getStripeSubscriptionProducts(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetStripeSubscriptionProducts = (options) => {
    const queryOptions = getGetStripeSubscriptionProductsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getStripeSubscription = (subscriptionId, options, signal) => {
    return client({ url: `/stripe/subscription/${subscriptionId}`, method: "GET", signal }, options);
};
export const getGetStripeSubscriptionQueryKey = (subscriptionId) => {
    return [`/stripe/subscription/${subscriptionId}`];
};
export const getGetStripeSubscriptionQueryOptions = (subscriptionId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStripeSubscriptionQueryKey(subscriptionId);
    const queryFn = ({ signal }) => getStripeSubscription(subscriptionId, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!subscriptionId,
        ...queryOptions,
    };
};
export const useGetStripeSubscription = (subscriptionId, options) => {
    const queryOptions = getGetStripeSubscriptionQueryOptions(subscriptionId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const deleteStripeSubscription = (subscriptionId, options) => {
    return client({ url: `/stripe/subscription/${subscriptionId}`, method: "DELETE" }, options);
};
export const getDeleteStripeSubscriptionMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { subscriptionId } = props ?? {};
        return deleteStripeSubscription(subscriptionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteStripeSubscription = (options) => {
    const mutationOptions = getDeleteStripeSubscriptionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const updateToPaidStripeSubscription = (subscriptionId, options) => {
    return client({ url: `/stripe/subscription/${subscriptionId}`, method: "PATCH" }, options);
};
export const getUpdateToPaidStripeSubscriptionMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { subscriptionId } = props ?? {};
        return updateToPaidStripeSubscription(subscriptionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateToPaidStripeSubscription = (options) => {
    const mutationOptions = getUpdateToPaidStripeSubscriptionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const manageStripeSubscriptionBilling = (stripeSubscriptionId, options) => {
    return client({
        url: `/stripe/subscription/manage/${stripeSubscriptionId}`,
        method: "POST",
    }, options);
};
export const getManageStripeSubscriptionBillingMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { stripeSubscriptionId } = props ?? {};
        return manageStripeSubscriptionBilling(stripeSubscriptionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const useManageStripeSubscriptionBilling = (options) => {
    const mutationOptions = getManageStripeSubscriptionBillingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getHealth = (options, signal) => {
    return client({ url: `/health`, method: "GET", signal }, options);
};
export const getGetHealthQueryKey = () => {
    return [`/health`];
};
export const getGetHealthQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();
    const queryFn = ({ signal, }) => getHealth(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetHealth = (options) => {
    const queryOptions = getGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCourseTeetimeSummary = (params, options, signal) => {
    return client({ url: `/course/teetime-summary`, method: "GET", params, signal }, options);
};
export const getGetCourseTeetimeSummaryQueryKey = (params) => {
    return [`/course/teetime-summary`, ...(params ? [params] : [])];
};
export const getGetCourseTeetimeSummaryQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCourseTeetimeSummaryQueryKey(params);
    const queryFn = ({ signal }) => getCourseTeetimeSummary(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetCourseTeetimeSummary = (params, options) => {
    const queryOptions = getGetCourseTeetimeSummaryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCourse = (params, options, signal) => {
    return client({ url: `/course`, method: "GET", params, signal }, options);
};
export const getGetCourseQueryKey = (params) => {
    return [`/course`, ...(params ? [params] : [])];
};
export const getGetCourseQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCourseQueryKey(params);
    const queryFn = ({ signal, }) => getCourse(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetCourse = (params, options) => {
    const queryOptions = getGetCourseQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAssistantThread = (params, options, signal) => {
    return client({ url: `/assistant/thread`, method: "GET", params, signal }, options);
};
export const getGetAssistantThreadQueryKey = (params) => {
    return [`/assistant/thread`, ...(params ? [params] : [])];
};
export const getGetAssistantThreadQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAssistantThreadQueryKey(params);
    const queryFn = ({ signal }) => getAssistantThread(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetAssistantThread = (params, options) => {
    const queryOptions = getGetAssistantThreadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAssistantMessages = (params, options, signal) => {
    return client({ url: `/assistant/message`, method: "GET", params, signal }, options);
};
export const getGetAssistantMessagesQueryKey = (params) => {
    return [`/assistant/message`, ...(params ? [params] : [])];
};
export const getGetAssistantMessagesQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAssistantMessagesQueryKey(params);
    const queryFn = ({ signal }) => getAssistantMessages(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetAssistantMessages = (params, options) => {
    const queryOptions = getGetAssistantMessagesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postAssistantMessage = (postAssistantMessageBody, options) => {
    return client({
        url: `/assistant/message`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: postAssistantMessageBody,
    }, options);
};
export const getPostAssistantMessageMutationOptions = (options) => {
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return postAssistantMessage(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
export const usePostAssistantMessage = (options) => {
    const mutationOptions = getPostAssistantMessageMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAssistantRun = (params, options, signal) => {
    return client({ url: `/assistant/run`, method: "GET", params, signal }, options);
};
export const getGetAssistantRunQueryKey = (params) => {
    return [`/assistant/run`, ...(params ? [params] : [])];
};
export const getGetAssistantRunQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAssistantRunQueryKey(params);
    const queryFn = ({ signal, }) => getAssistantRun(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export const useGetAssistantRun = (params, options) => {
    const queryOptions = getGetAssistantRunQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
